/* LogsViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
//const BaseLogsViewComponent = require("../../../../lib/logs/BaseLogsViewComponent");
const _ = require("lodash");
const Renderer = require("./LogsViewRenderer");

class LogsViewComponent extends EventEmitter /*extends BaseLogsViewComponent*/ {
    constructor(logger, gameEditor, state, io, TriggerEntity, storageFactory) {
        super(storageFactory);

        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._logId = state.logId;
        this._triggerEntityDef = TriggerEntity;
        this._triggerEntity = state.triggerEntity;
        this._workEntity = undefined;
        this._logFeed = undefined;

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
    }

    //feed handlers and pass-through function
    _registerLogFeedListeners() {
        this._logFeed.on(
            "ElementsInitialized",
            (this._onLogsInitialized = this._onLogsInitialized.bind(this))
        );
        this._logFeed.on(
            "ElementAdded",
            (this._onLogAdded = this._onLogAdded.bind(this))
        );
    }

    _unregisterLogFeedListeners() {
        if (this._logFeed) {
            this._logFeed.removeListener(
                "ElementsInitialized",
                this._onLogsInitialized
            );
            this._logFeed.removeListener(
                "ElementAdded",
                this._onLogAdded
            );
        }
    }

    _unregisterListeners() {
        this._unregisterLogFeedListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    
    get device() {
        return this._device;
    }

    get logFile() {
        return this.getLogFile();
    }

    getLogFile() {
        return this._logFile;
    }

    get io() {
        return this._io;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        
        return Promise.resolve(prom).then(() => {
            if (this._workEntity) {
                return this._workEntity.shutdown();
            }
            return Promise.resolve();
        }).then(() => {
            if(this._triggerEntityEvented && this._triggerEntityEvented.shutdown) {
                return this._triggerEntityEvented.shutdown();
            }
            return Promise.resolve();
        }).then(() => {
            this._triggerEntityEvented = undefined;
        });
    }

    async whenModelIsReady() {
        this._triggerEntityEvented = await this._triggerEntityDef.retrieveTrigger(this._gameEditor._activeOrgId, this._triggerEntity.getId());
        this._registerListeners();

        this._workEntity = await this._triggerEntityEvented.loadRelatedWork();

        if (!this._workEntity) {
            return;
        }

        this._logFeed = this._workEntity.startWorkLogElementFeed();

        this._registerLogFeedListeners();

        return this._logFeed.whenInitialized();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    // Log first initialized with all messages
    _onLogsInitialized(pristineProps) {
        this.emit("LogsInitialized", pristineProps);
    }

    // Log added as new messages are added
    _onLogAdded(pristineProps) {
        this.emit("LogAdded", pristineProps);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    get logId() {
        return this.getLogId();
    }

    getLogId() {
        return this._logId;
    }

    get logFeed() {
        return this.getLogFeed();
    }

    getLogFeed() {
        return !_.isEmpty(this._logFeed) ? Object.values(this._logFeed.getCache()) : [];
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = LogsViewComponent;

LogsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.viewState",
    "$teve.io",
    "$teve.entities.Trigger" /*,
    "$teve.entities.JobLog",
    "$teve.storageFactory"*/
];

LogsViewComponent.$displayDetails = {
    type: "View",
    name: "Logs",
    icon: "common.edit",
    shown: false
};
